var Quiz = {
  config: {},
  elQuiz: null,
  elControls: null,
  elContents: null,
  elQuestions: null,
  answers: [],
  questions: [],
  currentQuestion: null,
  products: [],
  results: null,
  fitSymbol: null,
  modeShopStyles: !1,
  fitSymbolShopStyles: null,
  heightShopStyles: null,
  shapeShopStyles: null,
  slickRealStarted: !1,
  init: function (i) {
    return (
      (this.config = i),
      this.log("Initializing quiz", this.config),
      (this.currentQuestion = this.config.questions.start),
      (this.elQuiz = $(this.config.selector)),
      (this.elControls = this.elQuiz.find(".quiz-controls")),
      (this.elContents = this.elQuiz.find(".quiz-contents")),
      (this.elQuestions = this.elContents.find(".quiz-questions")),
      this.initControls(),
      this.initQuestions(),
      this.gatherQuestions(),
      this
    );
  },
  start: function () {
    this.showQuestion(this.currentQuestion);
  },
  gatherQuestions: function () {
    var i = this;
    this.elQuestions.find(".quiz-question").each(function () {
      i.gatherQuestion($(this));
    }),
      this.log(this.questions);
  },
  gatherQuestion: function (i) {
    var t = i.find(".quiz-question-title").text(),
      e = i.attr("id"),
      s = [];
    i.find("input[type=radio]").each(function () {
      var i = $(this);
      s.push(i.val());
    }),
      this.questions.push({ id: e, title: t, answers: s });
  },
  nextQuestion: function () {
    this.currentQuestion++, this.showQuestion(this.currentQuestion);
  },
  prevQuestion: function () {
    this.currentQuestion--, this.showQuestion(this.currentQuestion);
  },
  showQuestion: function (i) {
    var t = this;
    $(".quiz-questions .quiz-question").removeClass("active"),
      $(".quiz-questions .quiz-question.question-" + i).addClass("active"),
      $(".quiz-controls .quiz-indicator a").removeClass("active"),
      $(".quiz-controls .quiz-indicator.indicator-" + i + " a").addClass(
        "active"
      ),
      this.updateSteps(),
      this.questionLoaded(i),
      setTimeout(function () {
        location.hash = t.getUrl(i).url;
      }, 500);
  },
  getUrl: function (i) {
    return this.config.urls.find(function (t) {
      return t.step === i;
    });
  },
  questionLoaded: function (i) {
    this.log("Loaded Question:" + this.currentQuestion),
      this.config.onQuestionLoaded(i);
    var t = this;
    3 == this.currentQuestion && this.updateSizeGroups(),
      4 == this.currentQuestion &&
        ($(document).on("click", ".real-example", function (i) {
          i.preventDefault(),
            t.slickRealStarted &&
              (t.log("unslicking..."),
              $(".real-preview .previewfeed").slick("unslick"),
              (t.slickRealStarted = !1)),
            $(".real-preview .preview-content").html("");
          for (
            var e = $(this).data("target"),
              s = e.substr(0, e.length - 1).split("|"),
              n = 0;
            n < s.length;
            n++
          )
            $(
              '<div class="image-slide"><img src="' + s[n] + '" /></div>'
            ).appendTo(".real-preview .preview-content");
          $(".real-preview").addClass("open"),
            $(".real-preview .previewfeed").slick({
              autoplay: !1,
              speed: 700,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: !1,
              dots: !0,
              prevArrow: "",
              nextArrow: "",
              responsive: [
                {
                  breakpoint: 900,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: !1,
                    dots: !0,
                    centerMode: !0,
                    centerPadding: "0",
                  },
                },
              ],
            }),
            (t.slickRealStarted = !0);
        }),
        $(document).on(
          "click",
          ".real-preview .preview-header a",
          function (i) {
            i.preventDefault(),
              $(this).closest(".real-preview").removeClass("open");
          }
        )),
      $("html,body").animate({ scrollTop: 0 }, 500);
  },
  quizFinished: function () {
    $("." + this.config.stylesQuestion + " .btn-continue").addClass("disabled"),
      this.log("finished");
    for (var i = {}, t = 0; t < this.answers.length; t++) {
      var e = this.answers[t];
      for (var s in e) i[s] = e[s];
    }
    if (
      ((i.products = this.products),
      this.log("results1", i),
      (this.results = i),
      this.modeShopStyles)
    ) {
      this.results.fitSymbol = this.fitSymbolShopStyles;
      if (this.getHeightForShopStyles()) {
        this.results.height = this.getHeightForShopStyles();
      }
      this.saveFitSymbol(this.results.fitSymbol);
      this.config.onQuizFinished(this.results);
    }
    else {
      var n = { f: "fitfinderSubmit" };
      (n.pantSize = i.size),
        (n.shape = i.shape),
        (n.carryWeight = i.weight),
        (n.fitFirst = i.tightest),
        (n.buySeperates = i.def_size),
        (n.identifier = this.getIdentifier()),
        (n.deviceType = this.getDeviceType()),
        (n.site = this.config.site),
        (n.email = i.optin),
        (n.uplineUrl = $("#hidFSDealerURL").val()),
        this.getFitSymbol(n);
    }
  },
  getIdentifier: function () {
    return this.config.identifier ? this.config.identifier : null;
  },
  saveFitSymbol: function (i) {
    this.saveCookie(this.config.cookieNamespace + "fitsymbol", i);
  },
  saveEmail: function (i) {
    this.saveCookie(this.config.cookieNamespace + "email", i);
  },
  updateSizeGroups: function () {
    this.log("Size Groups", this.answers);
    var sizeAnswer = this.answers.find(function (answer) {
      return answer.hasOwnProperty("size");
    });
    if (!sizeAnswer || sizeAnswer.size == null || sizeAnswer.size === "") return;
    var sizeClass = "group-" + sizeAnswer.size;
    $(".quiz-question .group").removeClass("active");
    $(".quiz-question .group").filter(function () {
      return this.classList.contains(sizeClass);
    }).addClass("active");
  },
  initControls: function () {
    this.log("Initializing controls...");
    var i = this;
    $(document).on(
      "click",
      ".quiz-steps .back a, .arrow-back .back a",
      function (t) {
        t.preventDefault(), i.prevQuestion();
      }
    ),
      $(document).on("change", "select.select-inseam", function (t) {
        i.log("Changed", $(this).val());
        var e = $(this).val(),
          s = $(this).data("type");
        i.addInseam(e, s);
      }),
      $(document).on("change", "input.qty-color", function (t) {
        var e = $(this).data("color").replace("color_", ""),
          s = $(this).val(),
          n = $(this).data("type"),
          o = $(this).closest(".blind").find("select.select-inseam").val();
        i.addColor(e, s, n, o);
      });
  },
  getProductByType: function (i) {
    for (var t = 0; t < this.products.length; t++)
      if (this.products[t].type === i) return this.products[t];
    return null;
  },
  addColor: function (i, t, e, s) {
    this.log("adding color");
    var n = this.getProductByType(e);
    if (n) {
      n.inseam = s;
      for (var o = !1, r = 0; r < n.colors.length; r++)
        if (n.colors[r].color === i) {
          0 === parseInt(t) ? n.colors.splice(r, 1) : (n.colors[r].qty = t),
            (o = !0);
          break;
        }
      o || (parseInt(t) > 0 && n.colors.push({ color: i, qty: t }));
    } else
      this.products.push({
        type: e,
        inseam: s,
        colors: [{ color: i, qty: t }],
      });
  },
  addInseam: function (i, t) {
    var e = this.getProductByType(t);
    e ? (e.inseam = i) : this.products.push({ type: t, inseam: i, colors: [] }),
      this.log(this.products),
      this.checkProducts();
  },
  checkProducts: function () {
    for (var i = !1, t = 0; t < this.products.length; t++)
      if (this.products[t].colors.length > 0) {
        i = !0;
        break;
      }
    i
      ? $("." + this.config.stylesQuestion + " .btn-continue").removeClass(
          "disabled"
        )
      : $("." + this.config.stylesQuestion + " .btn-continue").addClass(
          "disabled"
        );
  },
  initExpanders: function () {
    this.log("Initializing expanders..."),
      $(document).on(
        "click",
        ".images-preview .preview-header a",
        function (i) {
          i.preventDefault(),
            $(".images-preview .previewfeed").slick("unslick"),
            $(".images-preview").removeClass("open");
        }
      );
    var i = this,
      t = [];
    $(document).on("click", ".image-slider .expander", function (e) {
      t.length && (t = []), e.preventDefault(), i.log("gathering data...");
      var s = $(this);
      setTimeout(function () {
        location.hash = i.getUrl(s.data("target")).url;
      }, 500),
        $(this)
          .closest(".slick-track")
          .find(".slick-slide .img-wrapper img")
          .each(function () {
            for (var i = $(this).attr("src"), e = !1, s = 0; s < t.length; s++)
              if (t[s] === i) {
                e = !0;
                break;
              }
            e || t.push(i);
          }),
        i.log(t),
        $(".images-preview .previewfeed").html("");
      for (var n = 0; n < t.length; n++) {
        var o = $('<div class="previewslide"><img src="' + t[n] + '"></div>');
        $(".images-preview .previewfeed").append(o);
      }
      $(".images-preview").addClass("open"),
        $(".images-preview .previewfeed").slick({
          autoplay: !1,
          speed: 700,
          dots: !0,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: !1,
          prevArrow: "",
          nextArrow: "",
          responsive: [
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !1,
                dots: !0,
                centerMode: !0,
                centerPadding: "0",
              },
            },
          ],
        });
    });
  },
  initQuestions: function () {
    var i = this;
    $(".quiz-question").each(function () {
      var t,
        e = $(this);
      "optin" == e.attr("id")
        ? (t = e.find("input[type=text]")).change(function (t) {
            var e = $(this).val();
            (e = e.trim()),
              Simplistic.validateEmail(e) &&
                (i.answers.push({ [$(this).attr("name")]: e }),
                i.config.onQuestionAnswered({
                  question: i.currentQuestion,
                  value: e,
                }),
                i.updateButtons());
          })
        :(t = e.find("input[type=radio]")).change(function () {
          var selectedValue = e.find("input[type=radio]:checked").val();
          var answerName = t.attr("name");

          // save answer
          var existing = i.answers.find(function (obj) {
            return obj.hasOwnProperty(answerName);
          });

          if (existing) {
            existing[answerName] = selectedValue;
          } else {
            var o = {};
            o[answerName] = selectedValue;
            i.answers.push(o);
          }

          i.config.onQuestionAnswered({
            question: i.currentQuestion,
            value: selectedValue,
          });

          i.log(i.answers);

          // 🚀 auto move to next question
          setTimeout(function () {
            if (i.currentQuestion === i.config.questions.total) {
              i.quizFinished();
            } else {
              i.nextQuestion();
            }
          }, 200);
        });

    }),
      $(document).on("click", ".agree-to-terms", function (i) {
        return (
          i.preventDefault(),
          (newwindow = window.open(
            $(this).attr("href"),
            "agreeToTerms",
            "height=800,width=600"
          )),
          window.focus && newwindow.focus(),
          !1
        );
      }),
      $(document).on("click", ".quiz-question .btn-continue", function (t) {
        t.preventDefault(),
          i.dumpCookie(),
          i.currentQuestion == i.config.questions.total
            ? $(this).hasClass("disabled") || i.quizFinished()
            : $(this).hasClass("disabled") ||
              (i.modeShopStyles ? i.quizFinished() : i.nextQuestion());
      });
  },
  updateSteps: function () {
    1 == this.currentQuestion
      ? $(".quiz-steps .back a").hide()
      : $(".quiz-steps .back a").show(),
      $(".quiz-steps span.current").html(
        this.getDisplayPage(this.currentQuestion).display
      ),
      $(".quiz-steps span.total").html(this.config.questions.totalDisplay);
  },
  getDisplayPage: function (i) {
    return this.config.pages.find(function (t) {
      return t.step === i;
    });
  },
  updateButtons: function () {
    this.answers.forEach(function (i) {
      for (var t in i)
        $(".quiz-question#" + t + " .btn-continue").removeClass("disabled");
    });
  },
  dumpCookie: function () {
    if (this.config.saveProgress) {
      this.log("dumping cookie");
      var i = {
        currentQuestion: this.currentQuestion + 1,
        products: this.products,
        answers: this.answers,
      };
      this.log(i),
        this.log(JSON.stringify(i)),
        this.saveCookie(
          this.config.cookieNamespace + "quiz",
          JSON.stringify(i)
        );
    }
  },
  updateInseams: function (i) {
    this.log("updating inseams"), $(".select-inseam").html("");
    for (var t = 0; t < i.length; t++)
      $('<option value="' + i[t] + '">' + i[t] + '" Inseam </option>').appendTo(
        ".select-inseam"
      );
  },
  setShopStylesMode: function (i) {
    (this.currentQuestion = this.config.stylesQuestionNumber),
      (this.modeShopStyles = !0),
      (this.fitSymbolShopStyles = i.fitSymbol),
      (this.heightShopStyles = i.height),
      (this.shapeShopStyles = i.shape),
      this.log("setting modeShopStyles", i);
  },
  getHeightForShopStyles: function () {
    return this.heightShopStyles;
  },
  isShopStylesMode: function () {
    return this.modeShopStyles;
  },
  setReshopMode: function () {
    var i = this.getCookie(this.config.cookieNamespace + "fitsymbol");
    this.log("setting reshop mode...", i),
      i && this.setShopStylesMode({ fitSymbol: i });
  },
  getFitSymbol: function (i) {
    var t = this;
    console.log("data", i);
    var e = jQuery.ajax({
      data: { data: i },
      url: "https://shapelogictech.com/fitfinderNewB/requests.php",
      cache: !1,
      type: "post",
      timeout: 3e4,
    });
    e.done(function (i) {
      t.config.onLoadingFinished && t.config.onLoadingFinished(),
        i && i.success ? t.callResult(i) : t.fitfinderSubmitError(i);
    }),
      e.fail(function (i, e, s) {
        t.config.onLoadingFinished && t.config.onLoadingFinished(),
          console.error("fitfinderSubmit error: " + e, s),
          t.fitfinderSubmitError(null);
      });
  },
  getDeviceType: function () {
    var i = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry)/);
    return i ? (i.length > 1 ? i[0] : i) : "computer";
  },
  fitfinderSubmitError: function (i) {
    $("." + this.config.stylesQuestion + " .btn-continue").removeClass(
      "disabled"
    ),
      console.error("fitfinderSubmit returned error. " + JSON.stringify(i)),
      alert("There was an error getting your fit. Please try again.");
  },
  callResult: function (i) {
    var t = this;
    $.ajax({
      data: {
        g: "XMiCKn",
        $fields: "source",
        source: "Shopify Quiz",
        email: t.results.optin,
      },
      url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      cache: !1,
      type: "post",
      timeout: 3e4,
    })
      .done(function (e) {
        var s = s || [];
        if (
          (console.log("response", e, t.results),
          s.push([
            "identify",
            { $email: t.results.optin, FitlogicSize: i.fitSymbol },
          ]),
          null !== t.config.identifier)
        ) {
          var n = `${
            t.config.site
          }/a/smpl/custom_mm_quiz_proxy/updateResult?customer_id=${encodeURI(
            t.config.identifier
          )}&email=${encodeURI(t.results.optin)}&size=${encodeURI(
            i.fitSymbol
          )}&height=${encodeURI(t.results.height)}&shape=${encodeURI(
            t.results.shape
          )}`;
          console.log("updating mf", n),
            $.ajax({
              type: "GET",
              url: n,
              success: function (i) {},
              error: function (i) {},
            });
        }
        (t.results.fitSymbol =
          0 === i.fitSymbol.indexOf(".") ? "0" + i.fitSymbol : i.fitSymbol),
          (t.results.fitSymbol =
            i.fitSymbol.indexOf(".") === i.fitSymbol.length - 1
              ? i.fitSymbol + "0"
              : i.fitSymbol),
          t.saveFitSymbol(t.results.fitSymbol),
          t.saveEmail(t.results.optin),
          t.config.onQuizFinished(t.results);
      })
      .fail(function (i) {
        console.log("err", "err");
      });
  },
  saveCookie: function (i, t, e, s, n) {
    var o = n || document.domain;
    Cookies.set(i, t, { expires: e || 365, path: s || "/", domain: "." + o });
  },
  getCookie: function (i) {
    return Cookies.get(i);
  },
  log: function (i) {},
};